import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  MenuController, ModalController,
  NavController,
} from '@ionic/angular';

import {TranslateService} from "@ngx-translate/core";
import {
  DataService
} from "../../../services/common/data.service";
import {
  ViewService
} from "../../../services/common/view.service";
import {
  AuthService
} from "../../../services/common/auth.service";
import {AppComponent} from "../../../app.component";
import {
  AccountSettingsPage
} from "../../../pages/desktop/common/account-settings/account-settings.page";
import {Storage} from "@ionic/storage";
import {DemoService} from "src/app/services/common/demo.service";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidebarComponent implements OnInit {

  lang: any = {};
  // Consegne "prossimamente" su Balin per i clienti senza flag enable_consegne (vedi AppComponent).
  get consegneComingSoon(): boolean {
    return this.appComponent.isConsegneComingSoon();
  }
  showConsegneSubmenu: boolean = false;
  showOperativitaSubmenu: boolean = false;
  showAcquistaSubmenu: boolean = false;
  showAddonSubmenu: boolean = false;
  showAmministrazioneSubmenu: boolean = false;
  showSupportoSubmenu: boolean = false;
  showAddonMenu: boolean = false;

  actionButtons = {
    set1Top: [
      {
        action: () => {
          this.navCtrl.navigateRoot('users');
          this.toggleSidebar();
        },
        label: "gestione_utenti",
        testId: "step-guide-sidebar-users",
        icon: "relation",
        menu: null,
      },
      {
        action: () => {
          this.navCtrl.navigateRoot('cars');
          this.toggleSidebar();
        },
        label: "elenco_veicoli",
        icon: "traffic",
      },
      {
        action: () => {
          this.navCtrl.navigateRoot('routes-history');
          this.toggleSidebar();
        },
        label: "storico",
        icon: "menu-route",
      },
      {
        action: () => {
          this.navCtrl.navigateRoot('report');
          this.toggleSidebar();
        },
        label: "report",
        icon: "report-ingressi",
      },
    ],

    set1Bottom: [
      {
        action: async () => {
          this.navCtrl.navigateRoot('activation');
          this.toggleSidebar();
        },
        label: "attiva_localizzatori",
        icon: "addBtn",
      },
      {
        action: () => {
          this.navCtrl.navigateRoot('referral');
          this.toggleSidebar();
        },
        label: "referral",
        icon: "gift-box",
      },
    ],

    acquistaMenu: [
      {
        action: () => {
          this.navCtrl.navigateRoot('shop');
          this.toggleSidebar();
        },
        label: "acquista",
        icon: "cart",
      },
      {
        action: () => {
          this.navCtrl.navigateRoot('order-history');
          this.toggleSidebar();
        },
        label: "i_miei_ordini",
        icon: "shopping-bag",
      },
    ],

    operativita: [
      {
        action: () => {
          this.navCtrl.navigateRoot('plan-route');
          this.toggleSidebar();
        },
        label: "pianifica_viaggi",
        icon: "direction",
      },
      {
        action: () => {
          this.navCtrl.navigateRoot('list-plan-route');
          this.toggleSidebar();
        },
        label: "lista_viaggi",
        icon: "menu-route",
      },
      {
        action: () => {
          this.navCtrl.navigateRoot('report-ingressi');
          this.toggleSidebar();
        },
        label: "ingressi",
        testId: "step-guide-sidebar-report",
        icon: "report-ingressi",
      },
      {
        action: () => {
          this.navCtrl.navigateRoot('condivisione-posizione');
          this.toggleSidebar();
        },
        label: "condivisione_posizione",
        icon: "roadCursor",
      },
    ],

    amministrazioneSingle: [
      {
        action: () => {
          this.navCtrl.navigateRoot('payment');
          this.toggleSidebar();
        },
        label: "pagamenti_fatture",
        icon: "cards",
      },
    ],

    supporto: [
      {
        action: () => {
          this.navCtrl.navigateRoot('tickets');
          this.toggleSidebar();
        },
        label: "supporto",
        icon: "help",
      },
      {
        action: () => {
          this.navCtrl.navigateRoot('notifications');
          this.toggleSidebar();
        },
        label: "notifiche",
        testId: "step-guide-sidebar-notifications",
        icon: "bell",
      },
    ],

    set3: [
      {
        action: () => {
          console.log('action')
          if(AuthService.authTokenInUrl) this.storage.set('authToken', null).then(()=>{})
          this.auth.logout();
          this.toggleSidebar();
        },
        label: "logout",
        icon: "exit",
      },
    ],

    set4: [
      {
        action: () => {},
        label: "addon_itinerari",
        icon: "menu-route",
      },
    ],
  };

  // listener
  listener = {
    view: null
  };

  constructor(
    private menuCtrl: MenuController,
    private cd: ChangeDetectorRef,
    public view: ViewService,
    public data: DataService,
    private translate: TranslateService,
    private navCtrl: NavController,
    private auth: AuthService,
    public appComponent: AppComponent,
    private modalCtrl: ModalController,
    private storage: Storage,
    private demo: DemoService,
  ) {
  }

  /** Vero nella demo pubblica: il menu mostra "Registrati" al posto di "Esci". */
  get demoAttiva(): boolean {
    return DemoService.active;
  }

  /** Chiude la demo e porta alla registrazione. */
  registrati(){
    this.demo.esciERegistrati();
  }

  ngOnInit() {
    this.listenerView();
    ViewService.updateView.next(undefined);
    this.translate.get('SIDEBAR').subscribe((lang: any) => {
      this.lang = lang;
    });
    this.updateAddonMenuVisibility();
  }

  ngOnDestroy() {
    if (this.listener.view) {
      this.listener.view.unsubscribe();
    }
  }

  async toggleSidebar() {
    await this.menuCtrl.toggle("sidebar");
  }

  /** listener **/

  listenerView() {
    this.listener.view = ViewService.updateView$.subscribe((obj?: any) => {
      this.updateAddonMenuVisibility();
      this.view.pipeChanged++;
      this.cd.markForCheck();
      setTimeout(() => {
        this.cd.markForCheck();
      }, 250);
    });
  }




  // modal

  async openAccountSettings(){
    const modal = await this.modalCtrl.create({
      component: AccountSettingsPage,
      cssClass: "modal_alarm",
    });
    await modal.present();
  }

  async openContactAdd() {
    // console.log("openContactAdd()")

    // const modal = await this.modalCtrl.create({
    //   component: ContactAddPage,
    //   /*componentProps: {
    //    navData: {}
    //    },*/
    //   // backdropDismiss: false,
    //   // showBackdrop: false,
    //   cssClass: "modal_list",
    // });


    // //noinspection TypeScriptUnresolvedFunction
    // await modal.present();


    // /*//noinspection TypeScriptUnresolvedFunction
    //  const { data } = await modal.onWillDismiss();
    //  // console.log(data);

    //  if (data) {}*/
  }

  async openPage_ChatGroupNew() {
    // console.log("openPage_ChatGroupNew()")

    // const modal = await this.modalCtrl.create({
    //   component: ChatGroupNewPage,
    //   /*componentProps: {
    //    navData: {}
    //    },*/
    //   // backdropDismiss: false,
    //   // showBackdrop: false,
    //   cssClass: "modal_ChatGroupNew",
    // });


    // //noinspection TypeScriptUnresolvedFunction
    // await modal.present();


    // /*//noinspection TypeScriptUnresolvedFunction
    //  const { data } = await modal.onWillDismiss();
    //  // console.log(data);

    //  if (data) {}*/
  }

  openAddonPercorsi(event?: Event) {
    if (event) event.stopPropagation();
    this.navCtrl.navigateRoot('addon-percorsi');
    this.showAddonSubmenu = false;
    this.toggleSidebar();
  }

  openAddonLinee(event?: Event) {
    if (event) event.stopPropagation();
    this.navCtrl.navigateRoot('addon-percorsi-linee');
    this.showAddonSubmenu = false;
    this.toggleSidebar();
  }

  openAddonCorse(event?: Event) {
    if (event) event.stopPropagation();
    this.navCtrl.navigateRoot('addon-percorsi-corse');
    this.showAddonSubmenu = false;
    this.toggleSidebar();
  }

  openAddonLink(event?: Event) {
    if (event) event.stopPropagation();
    this.navCtrl.navigateRoot('addon-percorsi-link');
    this.showAddonSubmenu = false;
    this.toggleSidebar();
  }

  toggleAddonSubmenu(event?: Event) {
    if (event) event.stopPropagation();
    this.showAddonSubmenu = !this.showAddonSubmenu;
    if (this.showAddonSubmenu) {
      this.showOperativitaSubmenu = false;
      this.showAcquistaSubmenu = false;
      this.showAmministrazioneSubmenu = false;
      this.showSupportoSubmenu = false;
    }
    this.cd.markForCheck();
  }

  toggleConsegneSubmenu(event?: Event) {
    if (event) event.stopPropagation();
    this.showConsegneSubmenu = !this.showConsegneSubmenu;
    if (this.showConsegneSubmenu) {
      this.showOperativitaSubmenu = false;
      this.showAcquistaSubmenu = false;
      this.showAddonSubmenu = false;
      this.showAmministrazioneSubmenu = false;
      this.showSupportoSubmenu = false;
    }
    this.cd.markForCheck();
  }

  goConsegne(event?: Event) {
    if (event) event.stopPropagation();
    this.navCtrl.navigateRoot('addon-consegne');
    this.showConsegneSubmenu = false;
    this.toggleSidebar();
  }

  goCalendarioConsegne(event?: Event) {
    if (event) event.stopPropagation();
    // Su Balin (platform 1) Consegne è "prossimamente" → landing coming-soon;
    // su Flotta in Cloud (2) è live → calendario reale.
    this.navCtrl.navigateRoot(this.consegneComingSoon ? 'consegne-soon' : 'consegne');
    this.showConsegneSubmenu = false;
    this.toggleSidebar();
  }

  toggleOperativitaSubmenu(event?: Event) {
    if (event) event.stopPropagation();
    this.showOperativitaSubmenu = !this.showOperativitaSubmenu;
    if (this.showOperativitaSubmenu) {
      this.showAcquistaSubmenu = false;
      this.showAddonSubmenu = false;
      this.showAmministrazioneSubmenu = false;
      this.showSupportoSubmenu = false;
    }
    this.cd.markForCheck();
  }

  toggleAcquistaSubmenu(event?: Event) {
    if (event) event.stopPropagation();
    this.showAcquistaSubmenu = !this.showAcquistaSubmenu;
    if (this.showAcquistaSubmenu) {
      this.showOperativitaSubmenu = false;
      this.showAddonSubmenu = false;
      this.showAmministrazioneSubmenu = false;
      this.showSupportoSubmenu = false;
    }
    this.cd.markForCheck();
  }

  toggleAmministrazioneSubmenu(event?: Event) {
    if (event) event.stopPropagation();
    this.showAmministrazioneSubmenu = !this.showAmministrazioneSubmenu;
    if (this.showAmministrazioneSubmenu) {
      this.showOperativitaSubmenu = false;
      this.showAcquistaSubmenu = false;
      this.showAddonSubmenu = false;
      this.showSupportoSubmenu = false;
    }
    this.cd.markForCheck();
  }

  toggleSupportoSubmenu(event?: Event) {
    if (event) event.stopPropagation();
    this.showSupportoSubmenu = !this.showSupportoSubmenu;
    if (this.showSupportoSubmenu) {
      this.showOperativitaSubmenu = false;
      this.showAcquistaSubmenu = false;
      this.showAddonSubmenu = false;
      this.showAmministrazioneSubmenu = false;
    }
    this.cd.markForCheck();
  }

  private updateAddonMenuVisibility() {
    const organization: any = this.data?.selOrganization;
    if(!organization || !organization.platform_type){
      this.showAddonMenu = false;
      return;
    }

    const productIds = DataService.generalConfig.getAddonProductIdsByPlatform(organization.platform_type);
    if(!productIds || productIds.length === 0){
      this.showAddonMenu = false;
      return;
    }

    const orgAddons = organization.addons;
    if(!orgAddons){
      this.showAddonMenu = false;
      return;
    }

    if(Array.isArray(orgAddons)){
      this.showAddonMenu = orgAddons.some((addon: any) => {
        return addon && productIds.includes(addon.stripe_product_id) && addon.status === 'active';
      });
      return;
    }

    this.showAddonMenu = productIds.some((productId: string) => {
      return orgAddons[productId] && orgAddons[productId].status === 'active';
    });
  }





}
